import { connect } from 'react-redux';
import ShareLink from './share-link.component';
import { IShareLinkStoreProps } from './share-link.types';
import { State } from 'widgets/friends-referral/root/root.reducers';

const mapStateToProps = (state: State): IShareLinkStoreProps => ({
    invitationId: state.friendsReferral.playerInfo?.invitationId ?? '',
    activeLanguageCode: state.language.activeLanguageCode,
    shouldInheritStyles: state.config.shouldInheritStyles
});

const ShareLinkContainer = connect(
    mapStateToProps,
)(ShareLink);

export default ShareLinkContainer;
